import { render, staticRenderFns } from "./material-printability.vue?vue&type=template&id=1ce9a62b&"
import script from "./material-printability.vue?vue&type=script&lang=js&"
export * from "./material-printability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/sw-41f73918-1793878079/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ce9a62b')) {
      api.createRecord('1ce9a62b', component.options)
    } else {
      api.reload('1ce9a62b', component.options)
    }
    module.hot.accept("./material-printability.vue?vue&type=template&id=1ce9a62b&", function () {
      api.rerender('1ce9a62b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/roadrunner/Application/ViewComponents/Inshape/Admin/Materials/AddMaterial/PrintabilityComponent/material-printability.vue"
export default component.exports